import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useImperativeHandle, forwardRef } from 'react';

export interface FocusPluginRef {
  focus: () => void;
}

export const FocusPlugin = forwardRef<FocusPluginRef>((_, ref) => {
  const [editor] = useLexicalComposerContext();

  useImperativeHandle(ref, () => ({
    focus: () => {
      editor.focus();
    },
  }));

  return null;
});

FocusPlugin.displayName = 'FocusPlugin';
